import * as React from "react";

const VisaCard = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Capa_1"
    width="34"
    height="34"
    version="1.1"
    viewBox="0 0 16.207 16.207"
  >
    <g fill="#030104">
      <path d="M15.279 2.431H.928A.93.93 0 0 0 0 3.359v9.489c0 .512.416.928.928.928h14.351a.93.93 0 0 0 .928-.928v-9.49a.93.93 0 0 0-.928-.927m-.024 10.392-14.303.024-.024-9.465 14.327-.024z"></path>
      <path d="m2.303 6.792.481 3.446h1.181l2.202-4.267H4.926L3.991 7.95q-.198.42-.346.768a28 28 0 0 0-.062-.72l-.189-2.026H1.506l1.963 1.553zM7.015 10.239l.809-4.267H6.713l-.81 4.267zM7.666 9.987c.26.195.718.311 1.225.311 1.051 0 1.757-.594 1.757-1.477 0-.483-.282-.866-.861-1.169-.324-.182-.521-.304-.521-.458 0-.144.151-.299.509-.299.349 0 .615.137.666.164l.126.069.355-.95-.093-.052c-.266-.147-.596-.218-1.009-.218-1.006 0-1.709.588-1.709 1.43 0 .61.48.949.902 1.177.396.206.474.323.474.456 0 .256-.276.347-.513.347-.309 0-.631-.087-.884-.239l-.125-.074-.376.926zM11.72 10.239l.477-1.043h.962l.084 1.043h1.154l-.5-4.267h-1.291l-2.076 4.267zm1.16-2.636c.044-.096.089-.206.135-.319l.021.278.065.729h-.54z"></path>
    </g>
  </svg>
);

export default VisaCard;
